// Stepper configurations for different routes
export const stepperConfigs = {
  // Default proposal stepper
  default: {
    title: 'תהליך הוספת לקוח חדש',
    steps: [
      { id: 'borrower', name: 'פרטי הלקוח', path: '/proposal/borrower' },
      { id: 'reason', name: 'מטרת ההלוואה', path: '/proposal/:id/reason' },
      { id: 'assetValue', name: 'שווי הנכס', path: '/proposal/:id/assetValue' },
      { id: 'bankingConduct', name: 'התנהלות בנקאית', path: '/proposal/:id/bankingConduct' },
      { id: 'incomeLiabilities', name: 'הכנסות והתחייבויות', path: '/proposal/:id/incomeLiabilities' },
      { id: 'loanAmount', name: 'גובה ההלוואה', path: '/proposal/:id/loanAmount' },
      { id: 'offer', name: 'פרטי הצעה', path: '/proposal/:id/offer' },
      { id: 'borrowersDetails', name: 'פרטי הלווים', path: '/proposal/:id/borrowersDetails' },
      { id: 'summary', name: 'סיכום הצעה', path: '/proposal/:id/summary' },
      { id: 'routeType', name: 'סוג מסלול', path: '/proposal/:id/routeType' },
      { id: 'summary', name: 'סיכום הצעה', path: '/proposal/:id/summary' },
      { id: 'success', name: 'סיום', path: '/proposal/:id/success' },
    ],
    cancelPath: '/',
  },
  // Mortgage cycle stepper
  mortgageCycle: {
    title: 'תהליך שיפור משכנתא',
    steps: [
      { id: 'borrower', name: 'פרטי לווים', path: '/proposal/borrower' },
      { id: 'reason', name: 'מטרת ההלוואה', path: '/proposal/:id/reason' },
      { id: 'bankingConduct', name: 'התנהלות בנקאית', path: '/proposal/:id/bankingConduct' },
      { id: 'uploadBankFile', name: 'העלאת נתוני משכנתא נוכחית', path: '/proposal/:id/uploadBankFile' },
      { id: 'mortgageCycleAction', name: 'שיפור נתוני משכנתא נוכחית', path: '/proposal/:id/loansComparation' },
      { id: 'loansComparation', name: 'השוואת הלוואות', path: '/proposal/:id/mortgageCycleAction' },
      { id: 'borrowersDetails', name: 'פרטי הלווים', path: '/proposal/:id/borrowersDetails' },
      { id: 'mortgageCycleSummary', name: 'סיכום שיפור משכנתא קיימת', path: '/proposal/:id/mortgageCycleSummary' },
      { id: 'routeType', name: 'סוג מסלול', path: '/proposal/:id/routeType' },
      { id: 'success', name: 'סיום', path: '/proposal/:id/success' },
    ],
    cancelPath: '/',
  },
  replacementProperty: {
    title: 'תהליך דירה חלופית',
    steps: [
      { id: 'borrower', name: 'פרטי לווים', path: '/proposal/borrower' },
      { id: 'reason', name: 'מטרת ההלוואה', path: '/proposal/:id/reason' },
      { id: 'replacementProperty', name: 'משכנתא קיימת', path: '/proposal/:id/existingMortgage' },
      { id: 'assetValue', name: 'שווי הנכס', path: '/proposal/:id/assetValue' },
      { id: 'bankingConduct', name: 'התנהלות בנקאית', path: '/proposal/:id/bankingConduct' },
      { id: 'incomeLiabilities', name: 'הכנסות והתחייבויות', path: '/proposal/:id/incomeLiabilities' },
      { id: ' existBankLoan', name: 'מידע על משכנתא נוכחית', path: '/proposal/:id/existBankLoan' },
      { id: 'loanAmount', name: 'גובה ההלוואה', path: '/proposal/:id/loanAmount' },
      { id: 'borrowersDetails', name: 'פרטי הלווים', path: '/proposal/:id/borrowersDetails' },
      { id: 'existingMortgageSummary', name: 'סיכום', path: '/proposal/:id/existingMortgageSummary' },
      // סיכום
    ],
    cancelPath: '/',
  },
  anyPurposeWithPropertyCollateral: {
    title: 'תהליך הלוואה לכל מטרה עם שיעבוד נכס',
    steps: [
      { id: 'borrower', name: 'פרטי לווים', path: '/proposal/borrower' },
      { id: 'reason', name: 'מטרת ההלוואה', path: '/proposal/:id/reason' },
      { id: 'replacementProperty', name: 'משכנתא קיימת', path: '/proposal/:id/existingMortgage' },
      { id: 'assetValue', name: 'שווי הנכס', path: '/proposal/:id/assetValue' },
      { id: 'bankingConduct', name: 'התנהלות בנקאית', path: '/proposal/:id/bankingConduct' },
      { id: 'incomeLiabilities', name: 'הכנסות והתחייבויות', path: '/proposal/:id/incomeLiabilities' },
      { id: ' existBankLoan', name: 'מידע על משכנתא נוכחית', path: '/proposal/:id/existBankLoan' },
      { id: 'loanAmount', name: 'גובה ההלוואה', path: '/proposal/:id/loanAmount' },
      { id: 'borrowersDetails', name: 'פרטי הלווים', path: '/proposal/:id/borrowersDetails' },
      { id: 'existingMortgageSummary', name: 'סיכום', path: '/proposal/:id/existingMortgageSummary' },
      // סיכום
    ],
    cancelPath: '/',
  },
  renovationOrExpansion: {
    title: 'תהליך שיפוץ או הרחבה',
    steps: [
      { id: 'borrower', name: 'פרטי לווים', path: '/proposal/borrower' },
      { id: 'reason', name: 'מטרת ההלוואה', path: '/proposal/:id/reason' },
      { id: 'replacementProperty', name: 'משכנתא קיימת', path: '/proposal/:id/existingMortgage' },
      { id: 'assetValue', name: 'שווי הנכס', path: '/proposal/:id/assetValue' },
      { id: 'bankingConduct', name: 'התנהלות בנקאית', path: '/proposal/:id/bankingConduct' },
      { id: 'incomeLiabilities', name: 'הכנסות והתחייבויות', path: '/proposal/:id/incomeLiabilities' },
      { id: ' existBankLoan', name: 'מידע על משכנתא נוכחית', path: '/proposal/:id/existBankLoan' },
      { id: 'loanAmount', name: 'גובה ההלוואה', path: '/proposal/:id/loanAmount' },
      { id: 'borrowersDetails', name: 'פרטי הלווים', path: '/proposal/:id/borrowersDetails' },
      { id: 'existingMortgageSummary', name: 'סיכום', path: '/proposal/:id/existingMortgageSummary' },
      // סיכום
    ],
    cancelPath: '/',
  },
  // Business credit stepper
  businessCredit: {
    title: 'תהליך אשראי עסקי',
    steps: [
      { id: 'borrower', name: 'פרטי לווים', path: '/proposal/borrower' },
      { id: 'reason', name: 'מטרת ההלוואה', path: '/proposal/:id/reason' },
      { id: 'businessCredit', name: 'אשראי עסקי', path: '/proposal/:id/businessCredit' },
    ],
    cancelPath: '/',
  },
  // Business credit stepper
  reverseMortgage: {
    title: 'תהליך משכנתא הפוכה',
    steps: [
      { id: 'borrower', name: 'פרטי לווים', path: '/proposal/borrower' },
      { id: 'reason', name: 'מטרת ההלוואה', path: '/proposal/:id/reason' },
      { id: 'assetValue', name: 'שווי הנכס', path: '/proposal/:id/assetValue' },
      { id: 'bankingConduct', name: 'התנהלות בנקאית', path: '/proposal/:id/bankingConduct' },
      { id: 'routeType', name: 'סוג מסלול', path: '/proposal/:id/reverseMortgageRouteType' },
      { id: 'loanAmount', name: 'גובה ההלוואה', path: '/proposal/:id/loanAmountReverseMortgage' },
      { id: 'reverseMortgage', name: 'משכנתא הפוכה', path: '/proposal/:id/reverseMortgage' },
    ],
    cancelPath: '/',
  },
};

// Helper function to get stepper config based on loanTypeName
export const getStepperConfigByRoute = (loanTypeName) => {
  if (loanTypeName === 'mortgageRefinancing') {
    return stepperConfigs.mortgageCycle;
  } if (loanTypeName === 'businessCredit') {
    return stepperConfigs.businessCredit;
  } if (loanTypeName === 'reverseMortgage') {
    return stepperConfigs.reverseMortgage;
  } if (loanTypeName === 'renovationOrExpansion') {
    return stepperConfigs.renovationOrExpansion;
  } if (loanTypeName === 'replacementProperty') {
    return stepperConfigs.replacementProperty;
  } if (loanTypeName === 'anyPurposeWithPropertyCollateral') {
    return stepperConfigs.anyPurposeWithPropertyCollateral;
  }

  // Default stepper for other proposal routes
  return stepperConfigs.default;
};
